module.exports = __webpack_public_path__ + "static/img/baojingqueren.5fba6ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/baojingqueren.png
// module id = aE9I
// module chunks = 24